import React from 'react';
import { Box, Flex, Tooltip } from '@chakra-ui/react';

interface ISummaryList {
  title: string;
  children?: React.ReactNode;
  tooltip?: React.ReactNode;
  'data-selector'?: string;
}

export const SummaryList = (props: ISummaryList) => {
  const { title, children, tooltip, 'data-selector': dataSelector } = props;

  if (!children) {
    return null;
  }

  return (
    <Flex data-selector={dataSelector} borderTopWidth={1} _first={{ borderTopWidth: 0 }} gap={4} py={2} lineHeight={5}>
      {title && (
        <Box color="muted" width={'50%'} flexShrink={0}>
          {tooltip ? (
            <Tooltip hasArrow placement="top-start" label={tooltip}>
              {title}
            </Tooltip>
          ) : (
            title
          )}
        </Box>
      )}

      <Box as="ol">{children}</Box>
    </Flex>
  );
};
